import { Shield, Sun, Moon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useDarkMode } from '../context/DarkModeContext';

const Footer = () => {
  const { darkMode, toggleDarkMode } = useDarkMode();

  return (
    <footer className="bg-[#598615]/10 dark:bg-[#1B4332]/90 backdrop-blur-lg py-12 transition-colors duration-300">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2 text-[#EEF4E1]">
              <Shield className="w-6 h-6" />
              <span className="text-xl font-orbitron">Green Guard</span>
            </Link>
            <p className="text-[#DCE9C2]/80 dark:text-[#B7E4C7]/80">
              Protecting Your Financial Future with AI
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-[#EEF4E1] font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {['Features', 'About', 'Dashboard', 'Profile'].map((item) => (
                <motion.li key={item} whileHover={{ x: 5 }}>
                  <Link 
                    to={`/${item.toLowerCase()}`}
                    className="text-[#DCE9C2]/80 dark:text-[#B7E4C7]/80 hover:text-[#EEF4E1] transition-colors duration-300"
                  >
                    {item}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-[#EEF4E1] font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              {['Help Center', 'Privacy Policy', 'Terms of Service'].map((item) => (
                <motion.li key={item} whileHover={{ x: 5 }}>
                  <Link 
                    to={`/${item.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-[#DCE9C2]/80 dark:text-[#B7E4C7]/80 hover:text-[#EEF4E1] transition-colors duration-300"
                  >
                    {item}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-[#EEF4E1] font-semibold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="text-[#DCE9C2]/80 dark:text-[#B7E4C7]/80">support@greenguard.com</li>
              <li className="text-[#DCE9C2]/80 dark:text-[#B7E4C7]/80">+1 (555) 123-4567</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar with Dark Mode Switch */}
        <div className="mt-12 pt-8 border-t border-[#DCE9C2]/20 dark:border-[#B7E4C7]/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-4">
              <p className="text-[#DCE9C2]/60 dark:text-[#B7E4C7]/60 text-sm">
                © {new Date().getFullYear()} Green Guard. All rights reserved.
              </p>
              {/* Dark Mode Switch */}
              <motion.button
                onClick={toggleDarkMode}
                className="p-2 rounded-full bg-[#598615]/20 dark:bg-[#1B4332]/50 backdrop-blur-sm
                  hover:bg-[#598615]/30 dark:hover:bg-[#1B4332]/70 transition-all duration-300"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                {darkMode ? (
                  <Sun className="w-5 h-5 text-[#EEF4E1]" />
                ) : (
                  <Moon className="w-5 h-5 text-[#EEF4E1]" />
                )}
              </motion.button>
            </div>
            <div className="flex gap-6">
              {['Twitter', 'LinkedIn', 'GitHub'].map((social) => (
                <motion.a
                  key={social}
                  href={`#${social.toLowerCase()}`}
                  className="text-[#DCE9C2]/60 dark:text-[#B7E4C7]/60 hover:text-[#EEF4E1] text-sm transition-colors duration-300"
                  whileHover={{ y: -2 }}
                >
                  {social}
                </motion.a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 